import React from 'react';
import './GroomingOptions.css';
import GroomingPreference from './GroomingPreference';

const GroomingOptions = ({ selectedPetForGrooming, groomingBookingData, setGroomingBookingData }) => {
  function handleOptionSelect(question, option) {
    if (question === 'size') {
      setGroomingBookingData(function(prevData){
        const next = Object.assign({}, prevData);
        const go = next.groomingOptions ? Object.assign({}, next.groomingOptions) : {};
        go.selectedSize = option;
        next.groomingOptions = go;
        return next;
      });
    } else if (question === 'package') {
      setGroomingBookingData(function(prevData){
        const next = Object.assign({}, prevData);
        const go = next.groomingOptions ? Object.assign({}, next.groomingOptions) : {};
        go.selectedPackage = option;
        next.groomingOptions = go;
        return next;
      });
    }
  }

  const selectedSize = groomingBookingData && groomingBookingData.groomingOptions
    ? groomingBookingData.groomingOptions.selectedSize
    : undefined;

  const selectedPackage = groomingBookingData && groomingBookingData.groomingOptions
    ? groomingBookingData.groomingOptions.selectedPackage
    : undefined;

  // Determine cat vs dog from the full pet object
  const petType = selectedPetForGrooming && selectedPetForGrooming.type ? selectedPetForGrooming.type : 'Dog';
  const isCat = petType === 'Cat';

  // Packages: cats do NOT get 'teeth'
  const packageOptions = isCat
    ? ['nail', 'bath', 'touchup', 'grooming']
    : ['nail', 'bath', 'touchup', 'grooming', 'teeth'];

  // Build package buttons
  const packageButtons = [];
  for (let i = 0; i < packageOptions.length; i++) {
    const opt = packageOptions[i];
    let label = opt;
    if (opt === 'nail') label = 'Nail & Paw Care';
    else if (opt === 'bath') label = 'Luxury Bath & Blow Dry';
    else if (opt === 'touchup') label = 'Touch Up (Bath, Trim & Sanitary)';
    else if (opt === 'grooming') label = 'Full Groom (Bath, Haircut & Styling)';
    else if (opt === 'teeth') label = 'Teeth Scaling & Oral Care';

    packageButtons.push(
      <button
        key={opt}
        className={'option-button ' + (selectedPackage === opt ? 'selected-package-button' : '')}
        onClick={function(){ handleOptionSelect('package', opt); }}
      >
        {label}
      </button>
    );
  }

  // Size labels — same buttons & classes, just lighter ranges for cats
  const sizeSmallLabel  = isCat ? 'Small (~ 8 lbs)'    : 'Small (~ 10 lbs)';
  const sizeMediumLabel = isCat ? 'Medium (9 ~ 12 lbs)': 'Medium (11 ~ 30 lbs)';
  const sizeLargeLabel  = isCat ? 'Large (13 ~ 18 lbs)': 'Large (31 ~ 50 lbs)';
  const sizeXLLabel     = isCat ? 'X-Large (19 lbs ~)' : 'X-Large (51 lbs ~)';

  return (
    <div>
      <div className="options-container">
        <h2 className='options-header'>
          <span style={{ color: '#FFB516' }}>
            {selectedPetForGrooming && selectedPetForGrooming.name}
          </span>
          's Grooming Instructions
        </h2>

        {/* Pet Size */}
        <div className="option-group">
          <h3>Pet Size</h3>
          <div className="options">
            <button
              className={'option-button ' + (selectedSize === 'small' ? 'selected-size-button' : '')}
              onClick={function(){ handleOptionSelect('size', 'small'); }}
              disabled={selectedSize === 'small'}
            >
              {sizeSmallLabel}
            </button>
            <button
              className={'option-button ' + (selectedSize === 'medium' ? 'selected-size-button' : '')}
              onClick={function(){ handleOptionSelect('size', 'medium'); }}
              disabled={selectedSize === 'medium'}
            >
              {sizeMediumLabel}
            </button>
            <button
              className={'option-button ' + (selectedSize === 'large' ? 'selected-size-button' : '')}
              onClick={function(){ handleOptionSelect('size', 'large'); }}
              disabled={selectedSize === 'large'}
            >
              {sizeLargeLabel}
            </button>
            <button
              className={'option-button ' + (selectedSize === 'x-large' ? 'selected-size-button' : '')}
              onClick={function(){ handleOptionSelect('size', 'x-large'); }}
              disabled={selectedSize === 'x-large'}
            >
              {sizeXLLabel}
            </button>
          </div>
        </div>

        {/* Grooming Package */}
        <div className="option-group">
          <h3>Grooming Packages</h3>
          <div className="options">
            {packageButtons}
          </div>
        </div>

        <div className='option-group'>
          {/* petType passed so Preferences can show cat styles (including Cut Style) */}
          <GroomingPreference
            petType={petType}
            groomingBookingData={groomingBookingData}
            setGroomingBookingData={setGroomingBookingData}
          />
        </div>
      </div>
    </div>
  );
};

export default GroomingOptions;
